module.exports = __webpack_public_path__ + "static/media/in-app-promo.931e6de6.png";